import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Avatar, Row, Popover, Dropdown } from 'antd'
import { UserOutlined } from '@ant-design/icons'
import AvatarPopupMenu from './popupmenu'

const content = <AvatarPopupMenu />

const PhysioAvatar = (props) => {
  return (
    <div>
      {/* <Popover placement="bottom" content={content} trigger="click" style={{padding:0}}> */}
      <Dropdown overlay={content} placement={'bottomCenter'}>
        <div>
          <Row style={{ paddingTop: 10, justifyContent: 'center' }}>
            <Avatar src={props.userimage} icon={<UserOutlined />} />
          </Row>
          <Row
            style={{
              lineHeight: 1.5,
              color: 'white',
              fontStyle: 'underline',
              justifyContent: 'center',
              textDecoration: 'underline',
              cursor: 'pointer',
            }}
          >
            <a
              className='ant-dropdown-link'
              onClick={(e) => e.preventDefault()}
            >
              {props.username}
            </a>
          </Row>
        </div>
      </Dropdown>
      {/*  </Popover> */}
    </div>
  )
}

PhysioAvatar.propTypes = {
  username: PropTypes.string,
  userimage: PropTypes.string,
}

const mapStateToProps = (state) => {
  return {
    username: state.profile.user?.email,
    userimage: state.profile.user?.userimage,
  }
}

export default connect(mapStateToProps, null)(PhysioAvatar)
